// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1kzwq","file":"styles_file__1O8kG"};